import { MAX_DICTIONARY_WORD_LENGTH } from '../constants/max-dictionary-word-length'
import { WORD_RULE_MESSAGES } from '../constants/word-rule-messages'
import { containsLetter } from './contains-letter'

const WHITESPACE = /\s/u
const COMMA = ','
const DIGIT = /\p{Nd}/u

/** Whether the word is longer than a custom word may be, counted in characters like the backend. */
export function isTooLongForDictionary(word: string): boolean {
  return [...word].length > MAX_DICTIONARY_WORD_LENGTH
}

/**
 * The same rules as `wordRuleMessage`, worded for the fix popover, which says "Words can be up to 50
 * characters." (Figma "Word Rules / Add to Dictionary in the Fix Popover").
 */
export function popoverWordRuleMessage(word: string): string | null {
  const message = wordRuleMessage(word)

  return message === WORD_RULE_MESSAGES.tooLong ? WORD_RULE_MESSAGES.popoverTooLong : message
}

/**
 * Why a trimmed word can't be added, as the Add a word field shows it, or `null` when it can (or is
 * empty). Same rules and order as the backend: no spaces, no commas (Core 3 keeps words as a comma
 * separated list), at most 50 characters, at least one letter. Numbers-only and symbols-only words have separate copy in Figma.
 */
export function wordRuleMessage(word: string): string | null {
  if (!word) return null
  if (WHITESPACE.test(word)) return WORD_RULE_MESSAGES.hasSpace
  if (word.includes(COMMA)) return WORD_RULE_MESSAGES.hasComma
  if (isTooLongForDictionary(word)) return WORD_RULE_MESSAGES.tooLong
  if (!containsLetter(word)) {
    return DIGIT.test(word) ? WORD_RULE_MESSAGES.numbersOnly : WORD_RULE_MESSAGES.symbolsOnly
  }

  return null
}
